import { createContext } from "react";

export const ActivitiesContext = createContext({
  // Data
  activities: [],
  loaded: false,

  // Dialog state
  dialogOpen: false,
  editingActivity: null,
  openCreateDialog: () => {},
  openEditDialog: () => {},
  closeDialog: () => {},

  // Dialog form
  activityName: "",
  setActivityName: () => {},
  activityEmoji: "",
  setActivityEmoji: () => {},
  activityDescription: "",
  setActivityDescription: () => {},
  activityColor: "",
  setActivityColor: () => {},
  saving: false,
  handleSave: () => {},

  // Delete
  handleDelete: () => {},

  // Emoji picker
  emojiPickerOpen: false,
  setEmojiPickerOpen: () => {},

  // Color picker
  colorPickerAnchor: null,
  handleColorClick: () => {},
  handleColorPickerClose: () => {},
  handleColorSelect: () => {},

  // Random selector
  randomDialogOpen: false,
  openRandomSelector: () => {},
  closeRandomSelector: () => {},
  isSpinning: false,
  currentActivityIndex: 0,
  selectedActivity: null,
  spinSpeed: 100,
  startSpin: () => {},
});
